<template>
    <div class="row map">
        <l-map ref="mapRef" 
            :zoom="zoom" 
            :center="center" 
            :bounds="bounds"
        >
            <l-tile-layer :url="url" />
            <MarcadorMapa 
                v-for="(coordenada, index) in coordenadas" 
                :key="index" 
                :lat="coordenada.lat"
                :long="coordenada.long" 
                :icone="coordenada.icone || ''" 
                :texto="coordenada.texto || ''" 
            />
        </l-map>
    </div>
</template>

<script setup>
import { defineProps, ref, defineExpose, watch } from 'vue';
import { LMap, LTileLayer } from '@vue-leaflet/vue-leaflet';
import 'leaflet/dist/leaflet.css';
import MarcadorMapa from '@/components/Mapa/MarcadorMapa';

const props = defineProps({
    coordenadas: {
        type: Array,
        required: true,
        default: () => [{ texto: '', icone: '', lat: '0', long: '0' }],
    },
});

const mapRef = ref(null);
let center = ref(["-17.3085086", "-62.8432212"]);
let bounds = ref([]);
let zoom = ref(10);
const url = "https://{s}.tile.osm.org/{z}/{x}/{y}.png";

const centralizarMapa = () => {
    props.coordenadas.forEach((element) => {                
        if (element.texto === 'Origem') {
            center.value = [element.lat, element.long];
        }
        bounds.value.push([element.lat, element.long]);
    });
    
    if (bounds.value.length === 1) {
        center.value = bounds.value[0];
        zoom.value = 15;
    } else if (bounds.value.length > 1) {
        zoom.value = 8;
    }
}

defineExpose({
    invalidateSize() {
        mapRef.value?.leafletObject?.invalidateSize();
    },
    centralizarMapa
});


watch(() => props.coordenadas, () => {
    centralizarMapa();
}, { immediate: true, deep: true });
</script>

<style scoped>
.map {
    width: fit-content;
    height: fit-content;
    display: contents;
    margin: 0;
}
</style>
